// extracted by mini-css-extract-plugin
export default {"wrapper":"Characteristic_wrapper__qETWS","content":"Characteristic_content__zP1cq","title":"Characteristic_title__nNJh8","text":"Characteristic_text__6tI-z"};